import {AfterViewInit, ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {ModalDirective} from "ngx-bootstrap";
import {select} from "@angular-redux/store";
import {Subscribable} from "rxjs/Observable";
import {Subscription} from "rxjs/Subscription";

@Component({
  selector: 'vb-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoadingComponent implements OnInit, AfterViewInit, OnDestroy {

  @select(['session', 'isLoading']) loading;

  @ViewChild('loadingModal') public loadingModal: ModalDirective;

  public showLoadingModal(): void {
    this.loadingModal.show();
  }

  public hideLoadingModal(): void {
    this.loadingModal.hide();
  }

  private loadingSub: Subscription;

  constructor() {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.loadingSub = this.loading.subscribe((load: any) => {
      if (load) {
        this.showLoadingModal();
      } else {
        this.hideLoadingModal();
      }
    });

  }

  ngOnDestroy(): void {
    if (this.loadingSub) {
      this.loadingSub.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/loading/loading.component.ts